import React, { useEffect, useState } from 'react';
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";
import GovernanceCard from '../GovernanceCard/GovernanceCard';
import GovernanceSlider from '../GovernanceSlider/GovernanceSlider';
const Governance = () => {
    const [governInfo, setGovernInfo] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.governance_body,
            })
            .then((response) => {
                const governDoc = response.data.allGovernance_bodys.edges[0].node;
                setGovernInfo(governDoc);

            })
            .catch((error) => {
                console.error(error);
            });
    });


    return (
        <>
            <section id="team" className="team-container pattern">
                <div className="container stepper">
                    <div >
                        <h1 className="subtitle "> {governInfo?.title}</h1>
                        <GovernanceSlider sliderInfo={governInfo?.info} />
                        <div className="pt-5 pb-2">
                            <h1 className="subtitle  pb-4 ">{governInfo?.title2}</h1>
                            <div className=" d-flex align-items-center flex-column">

                                <div className="governance-container">

                                    <div className="row  g-4">
                                        {governInfo?.board_of_director?.map((govInfo, index) =>
                                            <GovernanceCard
                                                key={index + 1}
                                                index={index + 1}
                                                cardHeight={550}
                                                directorCard={true}
                                                sliderInfo={govInfo}
                                             
                                            />)}

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </section>
        </>

    );


};

export default Governance;